import type { AnchorGeneratedFamilyModel } from '@/shared/generated'
import type { TFunction } from 'i18next'

import {
	Operators,
	ValueEditorType,
	ValueType,
} from '@/shared/components/query-builder'

export const getFilterFields = (t: TFunction) => [
	{
		value: 'optimization_group_id',
		label: t('optimization_group'),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.multiselect,
		operations: [
			Operators.IS,
			Operators.IS_NOT,
			Operators.IN,
			Operators.NOT_IN,
			Operators.IS_EMPTY,
			Operators.IS_NOT_EMPTY,
		],
		enum: [],
	},
	{
		value: 'anchor_type',
		label: t('field_schema_anchor_type', { ns: 'fields' }),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.multiselect,
		operations: [Operators.IN, Operators.NOT_IN],
		enum: [],
	},
	{
		value: 'sales_entity_id',
		label: t('field_schema_pos_id', { ns: 'fields' }),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.checkboxTree,
		enum: [],
	},
	{
		value: 'anchor_strategy_name',
		label: t('field_schema_strategy_name', {
			ns: 'fields',
			defaultValue: 'Strategy name',
		}),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.text,
		enum: [],
	},
	{
		value: 'name',
		label: t('field_schema_anchor_family_name', {
			ns: 'fields',
			defaultValue: 'Family name',
		}),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.text,
		enum: [],
	},
	{
		value: 'status',
		label: t('field_schema_anchor_family_status', {
			ns: 'fields',
			defaultValue: 'Status',
		}),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.multiselect,
		enum: [],
	},
]
export const getSortedFamilyItems = (data: AnchorGeneratedFamilyModel[]) =>
	data.map(({ anchor_sku, anchor_generated_records, ...rest }) => ({
		...rest,
		anchor_sku,
		anchor_generated_records: [...anchor_generated_records].sort(
			(a, b) =>
				Number(b.sku === anchor_sku) - Number(a.sku === anchor_sku) ||
				Number(a.sku) - Number(b.sku)
		),
	}))
